var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.3221H7C5.93913 20.3221 4.92172 19.9007 4.17157 19.1505C3.42143 18.4004 3 17.3829 3 16.3221V10.0301C2.99999 9.3423 3.17732 8.66613 3.51487 8.06688C3.85242 7.46762 4.33879 6.96553 4.927 6.60908L9.927 3.57908C10.5521 3.20028 11.2691 3 12 3C12.7309 3 13.4479 3.20028 14.073 3.57908L19.073 6.60908C19.6611 6.96544 20.1473 7.46737 20.4849 8.06644C20.8224 8.6655 20.9998 9.34147 21 10.0291V16.3221C21 17.3829 20.5786 18.4004 19.8284 19.1505C19.0783 19.9007 18.0609 20.3221 17 20.3221Z",
    fill: "#5D6679",
    stroke: "#5D6679",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.3223H15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDashboard);
export default __webpack_public_path__ + "static/media/ActiveDashboard.a8e9efc1b9d94b1e8ac512f8648421dd.svg";
export { ForwardRef as ReactComponent };